<template>

<com-content :loading="is.loading" :text="text" :empty="!posts.length">

    <div class="blog-item" v-for="post in posts" :key="post.id">

        <div class="blog-item-avatar" :class="{'is-empty': !post.image}" :style="{backgroundImage: $util.thumbnail(post.image)}"></div>

        <div class="blog-item-text">

            <div class="blog-item-text-title">{{ post.name }}</div>
            <div class="blog-item-text-body">{{ post.text }}</div>
            <div class="blog-item-text-date"><span>{{ post.date | formatDate('D') }}</span><span>{{ post.date | formatDate('MMM') }}</span></div>

        </div>

    </div>

    <app-pagination :pages="pages" :current="current" v-on:change="onPageChange" />

</com-content>

</template>

<script>

import comContent from './common/Content'

export default {

    components: {
        'com-content': comContent
    },

    data: function() {

        return {
            is: {
                loading: false
            },
            posts: [],
            total: 0,
            pages: 1,
            current: 1
        }

    },

    computed: {

        text: function() {

            return {
                empty: this.page.blog_empty
            }

        }

    },

    created: function() {

        this.fetch()

    },

    methods: {

        onPageChange: function(page) {

            this.current = page
            this.fetch()

        },

        fetch: function() {

            this.is.loading = true

            this.$api.request('business/blog', {
                slug: this.page.business.slug,
                page: this.current
            }).then(function(json) {

                this.posts = json.items
                this.pages = json.pages
                this.current = json.page 
                this.total = json.total

                this.is.loading = false

            }.bind(this))

        }

    }

}

</script>

<style scoped>

.blog-item {
    border-radius: 4px;
    border: 1px solid var(--color-grey-light);
    padding: 20px;
    display: flex;
    flex-direction: row;
    transition: all 100ms linear;
    margin-bottom: 20px;
}

.is-mobile .blog-item {
    padding: 10px;
}

.is-desktop .blog-item:hover {
    border-color: var(--color-grey-highlight);
}

.blog-item:last-child {
    margin-bottom: 0px;
}

.blog-item-avatar {
    width: 120px;
    height: 120px;
    margin-right: 20px;
    background-position: 50% 50%;
    background-size: cover;
    flex-shrink: 0;
    background-color: var(--color-grey-light);
    border-radius: 4px;
}

.is-mobile .blog-item-avatar {
    width: 64px;
    height: 64px;
    margin-right: 10px;
}

.blog-item-avatar.is-empty {
    background-image: url(~@/assets/avatar.png);
    background-color: var(--color-blue-light);
    background-size: 64px auto;
    background-repeat: no-repeat;
}

.blog-item-text {
    flex-grow: 1;
}

.blog-item-text-title {
    font-family: "grueber",serif;
    font-size: 20px;
    line-height: 20px;
    color: var(--color-grey-dark);
    margin-bottom: 20px;
    padding-right: 64px;
}

.is-mobile .blog-item-text-title {
    font-size: 16px;
    line-height: 16px;
    margin-bottom: 10px;
}

.blog-item-text-body {
    color: var(--color-grey-dark);
    font-size: 14px;
    line-height: 18px;
    font-weight: 300;
}

.blog-item-text-date {
    position: absolute;
    right: -10px;
    transition: all 100ms linear;
    top: -10px;
    color: var(--color-grey-dark);
    background-color: var(--color-blue-light);
    color: #fff;
    border-radius: 4px;
    height: 40px;
    min-width: 40px;
    font-size: 14px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-transform: uppercase;
}

.is-mobile .blog-item-text-date {
    border-radius: 0px 4px 0px 4px;
}

.is-desktop .blog-item:hover .blog-item-text-date {
    background-color: var(--color-blue-dark);
}

.blog-item-text-date span:nth-child(1) {
    font-size: 20px;
    font-weight: 700;
}

</style>